import React from 'react'
import Header from 'components/Header'
import Footer from 'components/Footer'
import { Grid } from 'react-bootstrap'
import SitesLoader from 'routes/Sites'
import { connect } from 'react-redux'

const ApiInfo = connect(({ user }) => ({
  user
}))(({ user }) => (
  <>
    {user.data.name ?
      <div className="container">
        <div style={{
          // background: '#FEF7DB',
          background: 'rgba(108, 190, 84, 0.15)',
          padding: '16px 24px',
          marginBottom: '16px',
          fontSize: '14px'
        }}>
          <span>Теперь мы поддерживаем мультиформат в Adfox Header Bidding. На одном баннерном месте может использоваться несколько разных размеров баннера. По всем вопросам обращайтесь на <a href='mailto:media@soloway.ru'>media@soloway.ru</a></span>
        </div>
      </div> : <span />}
  </>
))

export default ({ children }) => (
  <div>
    <SitesLoader />
    <Header />
    <ApiInfo />
    <Grid>{children}</Grid>
    <Footer />
  </div>
);
